export const parseToNumber = (value: number | string) => isNaN(value as number) ? 0 : +value;
